import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Suggest, MultiSelect  } from '@blueprintjs/select';
import { MenuItem, FormGroup, NumericInput, Button, H3, H4, H6, ProgressBar } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
import  Chart from 'react-apexcharts';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import MaterialTable from 'material-table';
import { CsvBuilder } from "filefy";
import { rounded } from '../../../utils.js'

//import './DocStats.css';

//import { min } from 'lodash';

class DocStats extends React.PureComponent {

  state = {
    selectedDocId:"",
    windowSize:100,
    step:1,
    freqByWindow:[],
    height:350,
    freq:0,
    docList:[],
    data:{},
    waitingForDocStats:false,
    statType:0,
    selectedLemmas:[],
    catFilter:"",
    selectedItem:"",
    selectedRels:[],
    statTable: [], // cumulative table of stats for various doc
    docs: [], // list of documents that are in statTable
  }

  dataShape=[
    { name:'specificLemmaCat',label:this.props.t('specificLemmaCat'),type:"dict" },
    { name:'relDist',label:this.props.t('relDist'),type:"num" },
    { name:'nbCls',label:this.props.t('nbCls'),type:"num" },
    { name:'nbToks',label:this.props.t('nbToks'),type:"num" },
    { name:'nbPunct',label:this.props.t('nbPunct'),type:"num" },
    { name:'nbForms',label:this.props.t('nbForms'),type:"num" },
    { name:'lexicalDensity',label:this.props.t('lexicalDensity'),type:"num" },
    { name:'propPunct',label:this.props.t('propPunct'),type:"num" },
    { name:'formLength',label:this.props.t('formLength'),type:"num" },
    { name:'sentInDD',label:this.props.t('sentInDD'),type:"num" },
    { name:'nbFormsInDD',label:this.props.t('nbFormsInDD'),type:"num" },
    

  ];

  componentDidMount() {
    this.fetchDocList();
  }

  fetchDocList = () => {
    const endpoint = process.env.REACT_APP_API_BASE +'/get_doc_list.ajax.php';
    
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ session_id:this.props.session_id }),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        if (data.titledocid) {
          this.setState({ docList: data.titledocid });
        } else if (data.docid) {
          this.setState({ docList: data.docid });
        }
      });
    })
  }



  setSelectedDocId=(doc_selectedDocId) => {
    const m1=doc_selectedDocId.match(/docId=(([^/]+)\/(.*)#(\d+#\d+))/i);
    if (!m1) {
      console.log(doc_selectedDocId, "pas trouvé docId=")
      return;
    }
    const selectedDocId=m1[1];
    const collection=m1[2];
    const fileId=m1[3];
    const intervalSentNum=m1[4];
    const vocJsonFile=this.props.vocJsonFile;
    const language=this.props.language;
    const session_id=this.props.session_id;
    const globalNbToks=this.props.globalNbToks;

    const data={session_id,language,collection,fileId,intervalSentNum,vocJsonFile,globalNbToks};

    const endpoint = process.env.REACT_APP_API_BASE +'/get_doc_stats.ajax.php';
    
    this.setState({ waitingForDocStats:true });
    fetch(
        endpoint , {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        const statTable=this.state.statTable;
        const { nbToks, nbForms, nbContentWords, nbPunct, nbCls, nbSents, nbParas, averageFirstSentLengths, averageLastSentLengths, formLength, nbSentsInDD, nbBlocksInDD, nbFormsInDD } = data;
        // statTable initialization
        // at each new doc, the stats will be added in the table as a new column
        if (statTable.length===0) {
          statTable.push(
            { label:this.props.t('paraNumber')},
            { label:this.props.t('sentNumber')},
            { label:this.props.t('clsNumber')},
            { label:this.props.t('tokenNumber')},
            { label:this.props.t('formNumber')},
            { label:this.props.t('contentWordNumber')},
            { label:this.props.t('punctNumber')},
            { label:this.props.t('formLength')},
            { label:this.props.t('averageFirstSentLengths')},
            { label:this.props.t('averageLastSentLengths')},
            { label:this.props.t('nbSentsInDD')},
            { label:this.props.t('nbBlocksInDD')},
            { label:this.props.t('nbFormsInDD')},
          
          );
        }
        // adding new stats in statTable for new doc
        const newColName="doc"+(this.state.docs.length+1).toString();

        statTable[0][newColName]=Number(nbParas);
        statTable[1][newColName]=Number(nbSents);
        statTable[2][newColName]=Number(nbCls);
        statTable[3][newColName]=Number(nbToks);
        statTable[4][newColName]=Number(nbForms);
        statTable[5][newColName]=Number(nbContentWords);
        statTable[6][newColName]=Number(nbPunct);
        statTable[7][newColName]=Number(formLength);
        statTable[8][newColName]=Number(averageFirstSentLengths);
        statTable[9][newColName]=Number(averageLastSentLengths);
        statTable[10][newColName]=Number(nbSentsInDD);
        statTable[11][newColName]=Number(nbBlocksInDD);        
        statTable[12][newColName]=Number(nbFormsInDD);
           
         
        this.setState({ 
          data : data,
          statTable : [...statTable],
          docs:[...this.state.docs,selectedDocId],
          waitingForDocStats : false, 
          selectedDocId : selectedDocId, 
          selectedItem : doc_selectedDocId,
          selectedLemmas:[] 
        });
      });
    })
  }

  // if statType = specificLemma, the arg. lemma must be given
  calcTotByWindow = (lemmaOrRel) => {
    if (! this.state.data.docStats) {
      return [[],0,0];
    }

    // extraction de la liste des valeurs à prendre en compte (définie par this.state.statType)
    const values=this.state.statType < 2 ? // if statType = specificLemma
                  this.state.data.docStats.map( tab =>  tab[ this.state.statType ][lemmaOrRel]? 
                                                        tab[ this.state.statType ][lemmaOrRel]:
                                                        0 ):
                  this.state.data.docStats.map( tab => tab[ this.state.statType ] );
    if (! values) {
      return [[],0,0];
    }
    //console.log(values);
    //const average = array => array.reduce((a, b) => a + b) / array.length;
    //console.log("average",average(values));
    const serie=[];
    const m= this.state.selectedDocId.match(/#(\d+)#(\d+)$/);
    if (m && m[1] && m[2]) {
      const begin=parseInt(m[1]);
      const end=parseInt(m[2]);
      
      // middle désigne le centre de l'intervalle où l'on calcule les valeurs (sommes ou moyennes)
      var middle=begin;
      var min=values[begin];
      var max=values[begin];
      var globalTot=0;
      var globalN=0;
      const windowSize=this.state.windowSize-1;
      while (middle <= end ) {
        
        var tot=0;
        var n=0;
        // pour chaque middle, on calcule les bornes inf et sup de l'intervalle
        var firstI=Math.max(0,middle-Math.round(windowSize/2)-begin);
        var lastI=Math.min(end-begin,middle+Math.round(windowSize/2)-begin);
        // crop en fonction de la présence d'une div dans l'intervalle
        for (var i=firstI;i<=middle;i++) {
          if (this.state.data.docStats[i][0]['__divBreak__']) {
            firstI=i;
          }
        }
        for (i=middle;i<=lastI;i++) {
          if (this.state.data.docStats[i][0]['__divBreak__']) {
            lastI=i;
            break;
          }
        }

        for (i=firstI;i<=lastI;i++) {
          // for the relation distance, ignore the sentences with null value (no relation-> no mean)
          if (values[i]===0 && this.state.statType===1) {
            continue;
          }
          // for the relation distance, ignore min=0
          if (min===0 && this.state.statType===1) {
            min=values[i];
          }
          tot+=values[i];
          n++;
          globalTot+=values[i];
          globalN++;
          if (values[i]<min) {
            min=values[i]
          } else if (values[i]>max) {
            max=values[i]
          }
        }
        // console.log(firstI,lastI,middle);
        // for numeric values take the average (and not the frequency)
        if (this.dataShape[this.state.statType].type==='num') {
          if (n>0) {
            serie[middle]=tot/n;
          }
        } else {
          serie[middle]=tot;
        }
        
        // sliding window of 'step' sentences
        middle=middle+this.state.step;

      }
    }
    console.log(min,max,"Global mean",globalTot/globalN);
    return [serie,min,max];
  }

  selectLemma=(lemma)=>{
    if (! this.state.selectedLemmas.includes(lemma)) {
      this.setState({selectedLemmas:[...this.state.selectedLemmas, lemma]});
    }
  }

  
  removeLemma = (lemma)=>{
    const selectedLemmas=this.state.selectedLemmas;
    const index = selectedLemmas.indexOf(lemma);
    if (index > -1) { 
      selectedLemmas.splice(index, 1);
      this.setState({selectedLemmas:[...selectedLemmas]}); 
    }
  }

  selectRelation=(relation)=>{
    if (! this.state.selectedRels.includes(relation)) {
      this.setState({selectedRels:[...this.state.selectedRels, relation]});
    }
  }
  
  removeRelation = (relation)=>{
    const selectedRels=this.state.selectedRels;
    const index = selectedRels.indexOf(relation);
    if (index > -1) { 
      selectedRels.splice(index, 1);
      this.setState({selectedRels:[...selectedRels]}); 
    }
  }

  clearTable = () => {
    this.setState( { docs: [], statTable:[] })

  }

  // rajoute les limites dans le tableau upperLowerLimits, en fonction du seuil z, et renvoie xyTab
  calcSerie = (upperLowerLimits,data,serieName,min,max) => {
    const n=this.state.windowSize;
    const xyTab=[];

    console.log(serieName);
    const zThreshold=2.57; // valeur de z assurant une significativité de p=1/100
    const globalAverage=this.state.data["average"]? this.state.data["average"][serieName]:0;
    const globalVariance=this.state.data["variance"] ? this.state.data["variance"][serieName]:0;
    const maxSignificanceThreshold=globalAverage + zThreshold * Math.sqrt(globalVariance/n);
    const minSignificanceThreshold=globalAverage - zThreshold * Math.sqrt(globalVariance/n);

    //console.log(serieName," globalAverageFromPerl=",globalAverage,minSignificanceThreshold,maxSignificanceThreshold);

    // definitions des marques des limites inférieures et supérieures de significativité
    if (maxSignificanceThreshold<=max) {
      upperLowerLimits.push({
        y: maxSignificanceThreshold,
        borderColor: '#000',
        fillColor: '#FEB019',
        opacity: 0.2,
        label: {
          borderColor: '#333',
          style: {
            fontSize: '10px',
            color: '#333',
            background: '#FEB019',
          },
          text: 'UpperLimit',
        }
      });
    }
    if (minSignificanceThreshold>=min) {
      upperLowerLimits.push({
        y: minSignificanceThreshold,
        borderColor: '#000',
        fillColor: '#FEB019',
        opacity: 0.2,
        label: {
          borderColor: '#333',
          style: {
            fontSize: '10px',
            color: '#333',
            background: '#FEB019',
          },
          text: 'LowerLimit',
        }
      });
    }
    upperLowerLimits.push({
      y: globalAverage,
      borderColor: '#00E396',
      label: {
        borderColor: '#00E396',
        style: {
          color: '#fff',
          background: '#00E396',
        },
      },
      text: 'Average',
    });

    if (data.length>0) {
      for (var x=0;x<data.length;x++) {
        const val=data[x];

        if (val > 0 || (data[x-this.state.step]+data[x+this.state.step] > 0)) {
          xyTab.push(
            { x: x,
              y: val
            }
          );
        }
      }
    }
    return xyTab;
  }

  render() {
    const { t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    const items=this.state.docList;
    const docStats=this.state.data.docStats? this.state.data.docStats:[];
    //const { nbToks, nbForms, nbContentWords, nbPunct, nbCls, nbSents, nbParas, averageFirstSentLengths, averageLastSentLengths, formLength } = this.state.data;
    const { nbToks } = this.state.data;
    const statTypeOptions=this.dataShape.map( obj=> obj.label);

    const series=[];

    const listRels=this.state.data.relDist ? Object.keys(this.state.data.relDist).sort(): [];
    const minMax=[];
    var globalAverage;
    var globalStdDev;

    const upperLowerLimits=[];
    // numerical series : nbCls, etc.
    if (this.state.statType>1) {

      const [data,min,max]=this.calcTotByWindow();
      minMax[0]=min;
      minMax[1]=max;
      const serieName=this.dataShape[this.state.statType].name;

      const xyTab=this.calcSerie(upperLowerLimits,data,serieName,min,max);
      globalAverage=this.state.data["average"][serieName];
      globalStdDev=Math.sqrt(this.state.data["variance"][serieName]);
      // prep data for the chart
      series.push ({
        name: serieName,
        data: xyTab
      });
    // relation distances
    } else if (this.state.statType===1) {
      for (var rel of this.state.selectedRels) {
        const [data,min,max]=this.calcTotByWindow(rel);
        minMax[0]=min;
        minMax[1]=max;
        const serieName="distRel_"+rel;

        const xyTab=this.calcSerie(upperLowerLimits,data,serieName,min,max);
        globalAverage=this.state.data["average"][serieName];
        globalStdDev=Math.sqrt(this.state.data["variance"][serieName]);
       
        // prep data for the chart
        series.push ({
          name: rel,
          data: xyTab
        });
      }
    // adding one serie for each selected lemma
    } else {
      for (var lemma of this.state.selectedLemmas) {
        const xyTab=[];
        const [data,,]=this.calcTotByWindow(lemma);
        if (data.length>0) {
          for (var x=0; x<data.length; x++) {
            const val=data[x];

            if (val > 0 || (data[x-this.state.step]+data[x+this.state.step] > 0)) {
              xyTab.push(
                { x: x,
                  y: val
                }
              );
            }
          }
        }

        // prep data for the chart
        series.push ({
          name: lemma,
          data: xyTab
        });
      }
    // adding serie for the selected relation
    }  


    // building annotation for each divBreak
    const divAnnotations=[];
    const m= this.state.selectedDocId.match(/#(\d+)#\d+$/);
    var begin=0;
    if (m && m[1]) {
        begin=parseInt(m[1]);
    }
    for (var i=0;i<docStats.length;i++) {
      // pour la phrase i on enregistre dans le hachage des fréquences de lemme la clé __divBreak__
      if (docStats[i][0]['__divBreak__']) {
        divAnnotations.push(
          {
            x: i+begin,
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'Div',
              style: {
                color: "#fff",
                background: '#775DD0'
              }
            }
          }

        );
      }
    }

    const options = {
      
        chart: {
          type: 'line',
        },
        dataLabels: {
            enabled: false,
        },
        yaxis: {
            title: {
                text: this.dataShape[this.state.statType].label,
            },
            labels: {
                formatter: function (y) {
                  return y;
                }
            }
        },
        xaxis: {
            type: 'numeric',
            labels: {
                rotate: -90,
            },
        
        },
        annotations: {
          xaxis: divAnnotations,
          yaxis: upperLowerLimits,
        },
        stroke: {
          curve: 'stepline',
        }
      
    };

    // preparation of the table that includes the various doc stats
    const fields=["measure"];
    const columns=[
      { 
        title: t('docId'), 
        field: 'label',
      }
    ];
    
    i=1;
    for (var doc of this.state.docs) {
      const docNum="doc"+i.toString();
      columns.push(
        { 
          title: doc, 
          field: docNum, 
          render: rowData => Intl.NumberFormat(langFormat, { useGrouping: true }).format(rowData[docNum]),
          cellStyle: {
            textAlign:'center',
          },
        }
      )
      fields.push(doc);
      i++;
    }

    return(
      <>
          <Paper className="margin-bottom-1-5-rem padding-1-rem">
            <H3>{t('selectADoc')}&nbsp;

              <Suggest 
                width={300}
                items={items} 
                selectedItem={this.state.selectedDocId} 
                itemPredicate={(query, doc, _index, exactMatch) => { 
                  const normalizedTitle = doc ? doc.toLowerCase():""; 
                  const normalizedQuery = query? query.toLowerCase():"";

                  if (exactMatch) { 
                      return normalizedTitle === normalizedQuery; 
                  } else { 
                      return normalizedTitle.includes(normalizedQuery) 
                  } 
                }} 
                itemRenderer={(item, itemProps) => { 
                    return ( 
                        <MenuItem 
                            key={item} 
                            value={item}
                            text={item} 
                            onClick={(e) => { 
                              this.setSelectedDocId(e.target.textContent); 
                            }} 
                            active={itemProps.modifiers.active} 
                        /> 
                    ); 
                }} 
                onItemSelect={() => { }} 
                tagRenderer={(item) => item} 
                inputValueRenderer={(item) => item.toString()} 
              />

            </H3>
         
            {  this.state.waitingForDocStats && 
              <div>
                <br/>
                <br/>
                < ProgressBar />
              </div> }
            { ! this.state.waitingForDocStats && 
              <>
                <br/>
                { nbToks && this.state.docList.length>0 &&
                  <>  
                    <H6>{t('keyCaracteristics')}</H6>
                    <br/>
                    { this.state.docs.length>1 && 
                      <Button text={t('clearTable')} onClick={this.clearTable} />
                    }
                    <MaterialTable
                        title={t('statistics')}
                        columns={columns}
                        data={this.state.statTable}
                        options={{
                          filtering: false,
                          search: false,
                          sorting: false,
                          exportButton: true,
                          exportAllData: true,
                          paging: false,
                          padding: 'dense',
                        }}
                        components={{
                          exportCsv: (columns, data) => {
                            const fileName = "doc_stats";
                            const builder = new CsvBuilder(
                                fileName + ".csv"
                            );
                            builder
                                .setColumns( Object.keys(fields).sort() )
                                .setDelimeter(this.props.csvDelimiter).addRows(
                                  data.map((rowData) => Object.keys(fields).sort().map(key=>rowData.key))
                                )
                                .exportFile();
                          },
                          Container: props => (
                            <Paper
                              {...props}
                              elevation={0}
                            />
                          ),
                        }}
                    />
                    {/* <ul>
                        <li>{t('paraNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbParas)}</li>
                        <li>{t('sentNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbSents)}</li>
                        <li>{t('clsNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbCls)}</li>                        
                        <li>{t('tokenNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbToks)}</li>
                        <li>{t('formNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbForms)}</li>
                        <li>{t('contentWordNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbContentWords)}</li>                                                                        
                        <li>{t('punctNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(nbPunct)}</li>   
                        <li>{t('formLengthColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(formLength)}</li>                                                                     
                        <li>{t('averageFirstSentLengths')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(averageFirstSentLengths)}</li>                                                                        
                        <li>{t('averageLastSentLengths')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(averageLastSentLengths)}</li>                                                                        
                    </ul> */}
                  </>
                }

                <br/>
                <br/>
                { this.state.selectedItem && 
                    <>
                      <H4>{t('textMap')} -  {this.state.selectedItem}</H4>
                      <br/>
                      <div>{t('mapExplanation2')}</div>
                      <br/>
                      <FormGroup
                        label={t('windowSize')}
                        inline={true}
                      >
                        <NumericInput
                          min={1} buttonPosition={null}
                          value={this.state.windowSize}
                          onValueChange={(newValue) => this.setState({windowSize:newValue})}
                        />
                      </FormGroup>

                      <FormGroup
                        label={t('step')}
                        inline={true}
                      >
                        <NumericInput
                          min={1} buttonPosition={null}
                          value={this.state.step}
                          onValueChange={(newValue) => this.setState({step:newValue})}
                        />
                      </FormGroup>

                      <EnhancedSingleSelect
                        label={t('statType')}
                        name='statType'  // name is also used to make the input's `id`
                        hasDefault={true}
                        hasSelectableDefault={false}
                        options={statTypeOptions}
                        value={this.dataShape[this.state.statType].label}
                        onChange={ (e) => {
                                            e.preventDefault();
                                            const { value } = e.target;
                                            this.setState({ statType : statTypeOptions.indexOf(value) });
                                          }
                                  }
                      />

                      { this.state.data.keywords && this.state.statType===0 &&
                        <>
                          <FormGroup label={t('selectSpecificLemmas')} >
                            <MultiSelect
                              items={this.state.data.keywords.filter( v => (v!==null)? v.match('_'+this.state.catFilter):null)}
                              itemPredicate={(query, testedElement) => testedElement.includes(query)}
                              onItemSelect={(selectedItem) => this.selectLemma(selectedItem) }
                              onRemove={(selectedItem) => this.removeLemma(selectedItem) }
                              selectedItems={this.state.selectedLemmas}
                              tagInputProps={{
                                interactive: true,
                                onRemove: item => this.removeLemma(item),
                              }}
                              itemRenderer={
                                (item, { handleClick, modifiers }) => (
                                  <MenuItem
                                    key={"menuItems"+item}
                                    active={modifiers.active}
                                    text={item}
                                    icon={this.state.selectedLemmas.includes(item) ? 'tick' : 'blank'}
                                    onClick={handleClick}
                                    shouldDismissPopover={false}
                                  />
                                )
                              }
                              tagRenderer={item => item}
                              placeholder={t('selectSpecificLemmas')}
                            />
                            <EnhancedSingleSelect
                              label={t('filterByCat')}
                              options={this.state.data.cats? this.state.data.cats:[] }
                              name='filter'
                              hasDefault={true}
                              hasSelectableDefault={true}
                              onChange={ (e)=> this.setState( { catFilter : e.target.value }) }
                              popoverProps={{ minimal: true }}
                            />
                          </FormGroup>


                        </>                     
                      }

                      {/* Distance des relations */}
                      { this.state.statType===1 &&
                        <>
                          <FormGroup label={t('selectRelations')} >
                            <MultiSelect
                              items={ listRels }
                              itemPredicate={(query, testedElement) => testedElement.includes(query)}
                              onItemSelect={(selectedItem) => this.selectRelation(selectedItem) }
                              onRemove={(selectedItem) => this.removeRelation(selectedItem) }
                              selectedItems={this.state.selectedRels}
                              tagInputProps={{
                                interactive: true,
                                onRemove: item => this.removeRelation(item),
                              }}
                              itemRenderer={
                                (item, { handleClick, modifiers }) => (
                                  <MenuItem
                                    key={"menuItems"+item}
                                    active={modifiers.active}
                                    text={item}
                                    icon={this.state.selectedRels.includes(item) ? 'tick' : 'blank'}
                                    onClick={handleClick}
                                    shouldDismissPopover={false}
                                  />
                                )
                              }
                              tagRenderer={item => item}
                              placeholder={t('selectRelationsToCalcDistance')}
                            />
                          </FormGroup>
                        </>                     
                      }

                      { series.length>0 && 
                        <div className="margin-bottom-1-rem">
                          <br/>
                          <H6><u>{t('textMap')}</u></H6>
                          { minMax.length>0 && 
                            <p>min={minMax[0]}, max={minMax[1]}, mean={rounded(globalAverage,2)}, standard deviation={rounded(globalStdDev,2)} - {t('upperLimitLowerLimit')}</p>
                          } 
                          <div>
                            <Chart options={options} series={series} height={this.state.height}/> 
                          </div>
                        </div>
                      }
                  </>
                }
            </>
          }
        </Paper>

        
            
      </>
    );
  }

}

DocStats.propTypes = {
  subCorpora: PropTypes.array,
  session_id: PropTypes.string,
  language: PropTypes.string,
  globalNbToks: PropTypes.number,
  vocJsonFile: PropTypes.string,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(DocStats);
